import { withDialog } from "../compat/jquery-ui-dialog";
/**
 * Shared helpers — verbatim port of v1 common_utils.js (minus the api
 * transports, which live in api/logs-error.ts and api/file-upload.ts, and
 * findProductForm, which lives in checkout/find-product-form.ts per SPEC
 * §2.1 since the Phase-5 split).
 *
 * jQuery usage is load-bearing (research/01 Q1): PreventCheckoutOnEnter and
 * showDialog both use the BUNDLED $ (jquery-ui .dialog() is only registered
 * on the bundled copy — ERRATA #3/#15; DIV-002).
 */
import $ from "jquery";
import { appState } from "../state/app-state";
import { t } from "../i18n/translate";

export function buildDialogBlock(): string {
  return "<div style='display:none;'><div id='dialog' title='Basic dialog'><p>Your product isn't ready to go live. <br/>Delete all variants from the product and click save. <br/> </br/> Click <a target='_blank' href='https://support.custompricecalculator.com/en/articles/8077580-add-to-cart-not-working'>here</a> to learn more.</p></div></div>";
}

export function buildErrorBlock(): string {
  return "<div id='alert-block' class='hide-element alert float-left mt-4 w-100 clearfix alert-danger'>Please upload an image</div>";
}

export function generateStep(size: any): number {
  var num = 1;
  var s = num + "";
  while (s.length < size) s = "0" + s;
  if (size > 0) {
    s = "0." + s;
  }
  return parseFloat(s);
}

export function showDialog(): void {
  // DIV-031: jQuery UI's dialog loads on demand; synchronous when already present.
  withDialog(() =>
    $("#dialog").dialog({
      draggable: false,
      resizable: false,
      title: t("Custom Price Calculator Alert!"),
      width: 430,
      height: 230,
    }),
  );
}

export function globalHelper_Escape(input: any): any {
  input = input.replace(/\"/g, '\\"');
  return input;
}

// formatPricing moved to pricing/ticker.ts in the Phase-4 split (SPEC §2.1).

export function PreventCheckoutOnEnter(): void {
  $("#calculator").on("keypress", function (event: any) {
    console.log("checking for enter whether preseed for form.");
    var keyPressed = event.keyCode || event.which;
    if (keyPressed === 13) {
      console.log("Found Enter pressed for form.");
      event.preventDefault();
      return false;
    }
  });
}
